import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import {
  useGetLocalTransportRuleDetailQuery,
  useUpdateLocalTransportRuleMutation,
} from "store/services/LocalTransportRuleApi";
import LocalTransportRuleForm from "./LocalTransportRuleComponents/LocalTransportRuleForm";

const LocalTransportRuleEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: rule, isLoading: loadingDetail } =
    useGetLocalTransportRuleDetailQuery(id);
  const [updateRule, { isLoading: updating }] =
    useUpdateLocalTransportRuleMutation();

  const breadcrumbs = [
    {
      title: "Local Transports Rule",
      path: "/app/crm/local-transport-rule/list",
    },
    { title: "Edit Rule" },
  ];

  const handleUpdate = async (data) => {
    try {
      await updateRule({ _id: id, ...data }).unwrap();
      toast.success("Rule updated!");
      navigate("/app/crm/local-transport-rule/list");
    } catch (err) {
      toast.error(err?.data?.message || "Update failed");
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <LocalTransportRuleForm
          isBusy={loadingDetail || updating}
          ruleDetail={rule}
          onSubmit={handleUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LocalTransportRuleEditScreen;
